import MyAxios from "@/utilize/MyAxios";
import { useQuery } from "@tanstack/react-query";
import { PermissionNew } from "@/features/ACL/type";

export const useGetTrioPermission = () => {
  return useQuery({
    queryFn: () =>
      MyAxios.get<{
        permissions: PermissionNew[];
      }>("/acl/trio-permissions", {
        params: {
          page: 1,
          limit: 25,
        },
      }).then((res) => res.data),
    queryKey: ["TrioPermissions"],
  });
};
